import { polyLine2AABB2, polyLine2Copy, polyLine2Reflect, polyLine2SetCCW } from "geom/polyLine2";
import type { PolyLine2 } from "geom/polyLine2Types";
import type { PolyLine3 } from "geom/polyLine3";
import { polyLine3NonUniformScaleAndKeepCenter } from "geom/polyLine3";
import { ray2New } from "geom/ray2";

/**
 * @param profile a profile2 is assumed to be oriented with edge 0 being the bottom edge
 * @param centerX optional center X coordinate to use for mirroring. If not provided, the center X coordinate of the profile will be used.
 * @returns profile mirrored about the X axis, oriented
 */
export function mirrorPolyLine2XCopy(profile: PolyLine2, centerX?: number) {
  if (centerX === undefined) {
    const aabb2 = polyLine2AABB2(profile);
    centerX = (aabb2.maxX + aabb2.minX) / 2;
  }
  const p = polyLine2Copy(profile);
  polyLine2Reflect(p, ray2New(centerX, 0, 0, 1));
  return p;
}

/**
 * @param profile a profile2 is assumed to be oriented CCW
 * @returns
 */
export function mirrorProfile2Copy(profile: PolyLine2): PolyLine2 {
  return polyLine2SetCCW(mirrorPolyLine2XCopy(profile));
}

export function mirrorPolyLine3(p: PolyLine3): PolyLine3 {
  return polyLine3NonUniformScaleAndKeepCenter(p, -1, -1, 1);
}
